import React from "react";

const Conversation = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M10 12.6a1.6 1.6 0 0 1 1.6-1.6h12.8a1.6 1.6 0 1 1 0 3.2H11.6a1.6 1.6 0 0 1-1.6-1.6ZM10 19a1.6 1.6 0 0 1 1.6-1.6h9.6a1.6 1.6 0 1 1 0 3.2h-9.6A1.6 1.6 0 0 1 10 19Z"
        />
        <path
            fill={fill}
            fillRule="evenodd"
            d="M8.4 3A6.4 6.4 0 0 0 2 9.4v12.8a6.4 6.4 0 0 0 6.4 6.4H10v3.2a1.6 1.6 0 0 0 2.423 1.372l7.62-4.572H27.6a6.4 6.4 0 0 0 6.4-6.4V9.4A6.4 6.4 0 0 0 27.6 3H8.4ZM6.137 7.137A3.2 3.2 0 0 1 8.4 6.2h19.2a3.2 3.2 0 0 1 3.2 3.2v12.8a3.2 3.2 0 0 1-3.2 3.2h-8a1.6 1.6 0 0 0-.823.228L13.2 28.974V27a1.6 1.6 0 0 0-1.6-1.6H8.4a3.2 3.2 0 0 1-3.2-3.2V9.4a3.2 3.2 0 0 1 .937-2.263Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Conversation;